<template>
  <div>
    <DialogBase
      v-model="inputValue"
      :title="title"
      :isFooter="true"
      :width="width"
      isCardColor="true"
    >
      <template #title="{ dialogTitle }">
        <span class="pl-5 py-2 dialogTitleStyle">
          {{ $t(dialogTitle) }}
        </span>
      </template>

      <v-container fluid class="pa-2 baseStyle">
        <v-row v-for="(rec, index) in pageData" :key="index">
          <v-col>
            <ExpansionPanel :open="true" class="border rounded-lg">
              <template #header>
                <div class="d-flex align-center">
                  <div class="font-weight-bold py-4 tableTitleStyle">
                    {{ $t(rec.title) }}
                  </div>
                  <span v-if="rec.subText" class="d-flex align-center">
                    <NormalTextButton
                      :text="'＋' + $t(rec.subText)"
                      class="textButtonStyle"
                      @click.native="clicksubTextButton()"
                    />
                  </span>
                </div>
              </template>
              <template #content>
                <slot :name="rec.name" v-bind:item="rec"> </slot>
              </template>
              <template #footer>
                <slot :name="'expansionPanelFooter' + index" />
              </template>
            </ExpansionPanel>
          </v-col>
        </v-row>
      </v-container>

      <template #footer>
        <v-spacer> </v-spacer>
        <div class="ma-2 btnStyle">
          <NormalButton
            :text="$t('common.input_save')"
            textSize="16px"
            height="50px"
            width="100%"
            @click.native="complete()"
          />
        </div>
      </template>
    </DialogBase>
  </div>
</template>
<script>
import { NormalButton } from '@/components/items'
import DialogBase from '@/components/layouts/Dialogs/DialogBase'
import { ExpansionPanel } from '@/components/items'
import { NormalTextButton } from '@/components/items'
import { mapGetters } from 'vuex'

export default {
  components: {
    NormalButton,
    DialogBase,
    ExpansionPanel,
    NormalTextButton
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },
    pageData: {
      type: Array,
      require: true
    },
    productData: {
      type: Object,
      require: false,
      default: () => ({})
    }
  },
  data: () => ({
    //
  }),
  methods: {
    ...mapGetters('User', ['isSalonAccount']),
    complete() {
      if (this.productData.isNotAllowUpdate) {
        alert(this.$t('product.product_cannot-edit-integrate-product'))
        return
      }
      this.$emit('complete')
    },
    clicksubTextButton() {
      this.$emit('clicksubTextButton')
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.normalNumberInput {
  width: 180px;
}
.stepComponent {
  width: 150px;
}
.btnStyle {
  width: 130px;
}

.baseStyle {
  font-size: 14px;
}
.dialogTitleStyle {
  font-size: 22px;
}
.tableTitleStyle {
  padding-left: 30px;
  font-size: 15px;
}
.border {
  border: 1px solid #d8d8d8 !important;
}
.textButtonStyle {
  margin: 0px 21px;
}
</style>
